export default __webpack_public_path__ + "static/media/TaxiCDMX.3dc9213e.png";